<template>
    <v-input :rules="rules" v-model="myValue" @update:error="updateError">
        <editor v-model="myValue" :init="init" />
    </v-input>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import tinymce from 'tinymce';

import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

/* Import premium plugins */
/* NOTE: Download separately and add these to /src/plugins */
/* import './plugins/checklist/plugin'; */
/* import './plugins/powerpaste/plugin'; */
/* import './plugins/powerpaste/js/wordimport'; */

/* Import content css */
import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
import contentCss from 'tinymce/skins/content/default/content.css';

// SDK
import { mapActions } from 'vuex';

export default {
    components: {
        Editor,
    },
    props: {
        rules: Array,
        value: {
            type: String,
            default: '',
        },
        menubar: {
            type: [String, Array],
            default: 'file edit view insert format tools table help',
        },
        plugins: {
            type: [String, Array],
            default: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
        },
        toolbar: {
            type: [String, Array],
            default: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        },
    },
    data() {
        return {
            init: {
                height: 300,
                width: '100%',
                plugins: this.plugins,
                toolbar: this.toolbar,
                branding: false,
                menubar: this.menubar,
                image_advtab: true,
                image_caption: true,
                contextmenu: 'link image imagetools table',
                images_upload_handler: this.handleImageUpload,
                automatic_uploads: true,
                imagetools_cors_hosts: ['picsum.photos'],
                language: 'zh_TW',
                language_url: '/tinymce/lang/zh_TW.js',
            },
            myValue: this.value,
            error: false,
            imageDialogVisible: false,
        };
    },
    computed: {
        errorClass() {
            return {
                error: !!this.error,
            };
        },
    },
    methods: {
        ...mapActions('image', { createImage: 'create' }),
        updateError(error) {
            this.error = error;
        },
        async handleImageUpload(blobInfo, success, failure) {
            try {
                const resUri = await this.createImage(blobInfo.blob());
                const imgUrl = `${process.env.VUE_APP_BASE_URL}${resUri}`;
                success(imgUrl);
            } catch (e) {
                failure('上傳失敗，圖片超過1MB，或網路連線異常。');
            }
        },
    },
    mounted() {
        tinymce.init({
            selector: 'textarea#editor',
            skin: false,
            content_css: false,
            content_style: `${contentUiCss.toString()}\n${contentCss.toString()}`,
        });
    },
    watch: {
        value(newValue) {
            this.myValue = newValue;
        },
        myValue(newValue) {
            if (!newValue) {
                // eslint-disable-next-line no-param-reassign
                newValue = '';
            }
            this.$emit('input', newValue);
        },
    },
};
</script>
